import { TypePolicies } from '@apollo/client';
import Decimal from 'decimal.js';

import { GraphQLCurrencyUSD, GraphQLDecimal, GraphQLPercent, GraphQLTime } from '../scalars';

export const typePolicies: TypePolicies = {
  AISuggestion: {
        fields: {
          beneficialOwnersAsOfDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

AISuggestionEvidence: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

AccessAgeParameter: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

AccessParameter: {
        fields: {
          amount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
percentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Account: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ActiveEstateInsightsPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Activity: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Address: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

AmountAccessParameterView: {
        fields: {
          amount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

Answer: {
        fields: {
          confirmedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

AnswerEvidence: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

AnswerRevision: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ApplicationRecordAsset: {
        fields: {
          previousValueUSD: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
valueUSD: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

ApplicationRecordLiability: {
        fields: {
          currentAmountUSD: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

ApplicationRecordLifeInsurancePolicy: {
        fields: {
          cashValueUSD: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
deathBenefitUSD: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

ApplicationRecordOwnershipStake: {
        fields: {
          percentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

ApplicationRecordProvisionShare: {
        fields: {
          amountUSD: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
formulaicPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
limitUSD: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
percentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

Approval: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

AssetClass: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
growthRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDragRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

AssetGroup: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

AssetStatic: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

AssetV2: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
ownedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

AssetValuationV2: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
fixedValuationAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
valuationValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

AssetValueV2: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
ownedPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ownedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
shareCount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
shareValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

AsyncJob: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

BalanceSheetBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

BalanceSheetCategory: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

BalanceSheetRowValue: {
        fields: {
          secondaryValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

BalanceSheetViewConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

BasicEntityDetailsSuggestion: {
        fields: {
          valuationAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

BeneficiariesBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

BeneficiariesTemplateBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Beneficiary: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

BeneficiaryAccessParameter: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

BeneficiaryDesignationGroup: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

BeneficiaryDistribution: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
distributionAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
distributionPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

BeneficiaryDistributionParameter: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

BeneficiaryPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

BeneficiaryPowerOfAppointment: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

BeneficiaryReportAccessBreakdown: {
        fields: {
          beneficialTotal: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

BeneficiaryReportBeneficiaryBreakdown: {
        fields: {
          currentAccessAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
futureAccessAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
futureDistributions: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
pastDistributionAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

BeneficiaryReportEntityAccess: {
        fields: {
          accessFraction: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
accessibleValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
entityValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

BeneficiaryReportEntityBreakdown: {
        fields: {
          beneficialAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
entityValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

BeneficiaryReportYearByYearBeneficiaryAccess: {
        fields: {
          distributionsToDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
newTrustAccess: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
trustAccessToDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

CCorpBusinessEntity: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
nongrantorControlledPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
nongrantorControlledValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ownershipAsOfDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

CLTOptimization: {
        fields: {
          annuityPayoutAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
unitrustPayoutPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

CLTProposal: {
        fields: {
          annuityPayoutAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
assetCostBasis: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
assetValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
preTaxReturnPercentageHigh: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
preTaxReturnPercentageLow: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
preTaxReturnPercentageMedium: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
rate7520: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDragPercentageHigh: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDragPercentageLow: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDragPercentageMedium: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
unitrustPayoutPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

CLTProposalProjection: {
        fields: {
          capitalGainsDeferred: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
capitalGainsTaxDeferred: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
charitableBenefit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
estateTaxSaved: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ordinaryIncomeTaxSaved: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
personalBenefit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
personalRemainder: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
projectedCharitableBenefit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
rate7520: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableGift: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

CLTProposalYearlyProjection: {
        fields: {
          beginningOfYear: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
cumulativeCharity: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
cumulativeTaxed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
growth: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
payout: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
remainderValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

CLTTrust: {
        fields: {
          charitableDeduction: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
officialInterestRatePercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
termEndDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
terminationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

CRTOptimization: {
        fields: {
          annuityPayoutAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
unitrustPayoutPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

CRTProposal: {
        fields: {
          annuityPayoutAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
assetCostBasis: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
assetValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
preTaxReturnPercentageHigh: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
preTaxReturnPercentageLow: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
preTaxReturnPercentageMedium: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
rate7520: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDragPercentageHigh: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDragPercentageLow: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDragPercentageMedium: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
unitrustPayoutPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

CRTProposalProjection: {
        fields: {
          capitalGainsDeferred: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
capitalGainsTaxDeferred: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
charitableRemainder: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ordinaryIncomeTaxSaved: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
personalBenefit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
personalPortfolio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
projectedCharitableRemainder: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
rate7520: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

CRTProposalYearlyProjection: {
        fields: {
          beginningOfYear: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
cumulativeIncome: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
cumulativeTaxed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
growth: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
payout: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
remainderValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

CRTTrust: {
        fields: {
          charitableDeduction: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
officialInterestRatePercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
termEndDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
terminationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Capability: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Cashflow: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
growthPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
transferPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
transferValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

CharitableOrganizationPerformanceReport: {
        fields: {
          directGifts: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalWealthTransferred: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

ClientOrganization: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ClientOverallPerformanceReport: {
        fields: {
          impliedEstateTaxSavings: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateGrowth: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalWealthTransferred: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

ClientPresentationV2: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ClientProfile: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentAnnualExclusionUsed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
dateOfBirth: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
dateOfDeath: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
gstExclusionUsed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
lifetimeExclusionUsed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
pastDistributions: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
remainingGSTExclusion: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
remainingLifetimeExclusion: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
remainingStateExemption: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
stateExemptionUsed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalAnnualExclusionUsed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalStateExemption: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ClientProfileRelationship: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Collaborator: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
lastViewedNotificationsListAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ComparedWaterfall: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

CompletedEstateInsightsPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ControllingParty: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Conversation: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

CoverPageConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

CustodialPersonalAccount: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DSUEPortability: {
        fields: {
          amount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
eventDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DiagramArtifact: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DiagramArtifactPrompt: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DispositionScenario: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
reviewedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DispositiveProvision: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
dispositionAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
dispositionFormulaicPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
dispositionLimit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
dispositionPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DispositiveProvisionTemplate: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DividerBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DividerTemplateBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Document: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DocumentQuestion: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DocumentQuestionAnswers: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DocumentSummary: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DocumentSummaryPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DocumentSummaryPrompt: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DocumentSummaryPromptTestRun: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DocumentSummaryTemplateBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

DonorAdvisedFund: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Employee: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
lastViewedNotificationsListAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
lastViewedPresentationApprovalsAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
workosUpdatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EntitiesOverviewBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EntitiesOverviewBundleConfigurationEntity: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Entity: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentLiabilitiesOwed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentLiabilitiesOwned: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EntityDiagram: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EntityDocumentRelationship: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EntityGraphView: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EntityGraphViewBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EntityNotes: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EntityProposal: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDrag: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EntitySummaryBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EntitySummaryTemplateBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EntityTask: {
        fields: {
          completedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
dueAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EntityTaxInfo: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EstateInsight: {
        fields: {
          completedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EstateInsightReference: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EstateInsightsBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EstateTaxScenario: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EstateWaterfall: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EstateWaterfallHypotheticalStateChange: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EstateWaterfallHypotheticalTransfer: {
        fields: {
          assetGrowthReturn: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
transferValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EstateWaterfallLoanValueHistory: {
        fields: {
          beginningOfYearValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
endOfYearValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
interestPaid: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
principalPaid: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallMessageContext: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EstateWaterfallNodeValueHistory: {
        fields: {
          assetGrowth: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
beginningOfYearValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
endOfYearValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
valueBeforeDispositions: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallOwnedObject: {
        fields: {
          ownershipPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallPrimaryClientValuesBeforeDispositions: {
        fields: {
          firstDeathValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
secondDeathValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallTransfer: {
        fields: {
          availableTransferAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
desiredTransferAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
finalTransferAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallVisualizationConfig: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EstateWaterfallVisualizationFilter: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

EstateWaterfallViz: {
        fields: {
          firstDeathInEstateInsuranceBenefit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
firstDeathInsuranceBenefit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
firstDeathOutOfEstateInsuranceBenefit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
firstDeathRemainingLifetimeExemption: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
firstGrantorRemainingLifetimeExemptionAtDeath: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
lifetimeExemptionAppliedTowardsGiftTax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
secondDeathInEstateInsuranceBenefit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
secondDeathInsuranceBenefit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
secondDeathOutOfEstateInsuranceBenefit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
secondDeathRemainingLifetimeExemption: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
secondGrantorRemainingLifetimeExemptionAtDeath: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallVizEdge: {
        fields: {
          value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallVizEdgeAssociatedDispositiveProvision: {
        fields: {
          value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallVizEdgeAssociatedHypotheticalCLT: {
        fields: {
          value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallVizEdgeAssociatedHypotheticalCRT: {
        fields: {
          value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallVizEdgeAssociatedHypotheticalGRAT: {
        fields: {
          value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallVizEdgeAssociatedHypotheticalInsurance: {
        fields: {
          value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallVizEdgeAssociatedLoan: {
        fields: {
          value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallVizEdgeAssociatedTransfer: {
        fields: {
          value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

EstateWaterfallVizNode: {
        fields: {
          addedDeathBenefit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
assetValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
futureDeathBenefit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
liabilityValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
nonTaxableValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
receivableValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
transferredToEstateTax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
transferredToGiftingTax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
valueBeforeDispositions: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
valueBeforePouroverWills: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

FamilyTreeBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

FamilyTreeConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

FeatureFlag: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

FeatureFlagQueryRule: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

FederalTaxDetail: {
        fields: {
          exemptionAvailable: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
exemptionUsed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grossEstate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
gstTaxDeductions: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
nonTaxableTransfers: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
stateTaxDeductions: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
tax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
valuationDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

File: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
fileUploadedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

FilePage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

FileParagraph: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Form: {
        fields: {
          archivedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

FormAnswerNode: {
        fields: {
          numberValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

FormSubmissionDiagnosticAttempt: {
        fields: {
          endedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
startedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

FormVersion: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

GPBusinessEntity: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
nongrantorControlledPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
nongrantorControlledValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ownershipAsOfDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

GRATAnnuityV2: {
        fields: {
          actualPaymentAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
computedInitialFundingValuePercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
computedPaymentAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
failedAnnuityPaymentAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
initialFundingValuePercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
paidOn: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
paymentWindowEndDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
paymentWindowStartDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

GRATProposalScenario: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
inTermCAGRV2: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
projectedAnnualReturnAfterTerm: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
projectedAnnualReturnThroughTerm: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
projectedMarketValueAtTerm: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

GRATTrust: {
        fields: {
          annuityAnnualIncreasePercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
completionDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
distributionDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
downsideThresholdPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorRetainedInterest: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
impliedEstateTaxSavings: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
initialFundingValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
officialInterestRatePercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
projectedMarketValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
projectedRateOfReturn: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
projectedSharePrice: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
targetTaxableGift: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableGift: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
termEndDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
upsideThresholdPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
upsideThresholdValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

GSTTaxDetail: {
        fields: {
          exemptionAvailable: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
exemptionUsed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
tax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalTransferAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
valuationDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

GiftTaxDetail: {
        fields: {
          exemptionUsed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
tax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableGiftsMade: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

GiftingProposal: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
exemptionGrowthRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inEstatePortfolioValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
preTaxReturnPercentageHigh: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
preTaxReturnPercentageLow: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
preTaxReturnPercentageMedium: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDragPercentageHigh: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDragPercentageLow: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDragPercentageMedium: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

GiftingProposalCashFlow: {
        fields: {
          amount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
growthPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

GiftingProposalGift: {
        fields: {
          amount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
discountPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
growthPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

GiftingProposalGiftSender: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

GiftingProposalPortfolio: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
startingAssetValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

GiftingProposalProjections: {
        fields: {
          estateTax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
giftTax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inEstateValueAfterTax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inEstateValueBeforeTax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
lifetimeExemptionAppliedTowardGiftTax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateCharitableValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateFamilyValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateTotalValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
remainingLifetimeExemption: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableGift: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

GiftingProposalScenario: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

GiftsToIndividualsPerformanceReport: {
        fields: {
          wealthTransferred: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

GrantsToCharitableOrganizations: {
        fields: {
          wealthTransferred: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

GraphVisualizationGroup: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

GrowthProfile: {
        fields: {
          assetGrowthReturn: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
exemptionGrowthRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

GrowthProfileOverride: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
customGrowthRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
entityFutureValuationValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
entityGrowthAfterFutureValuation: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
entityGrowthBeforeFutureValuation: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Household: {
        fields: {
          archivedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
newIndividualsAutomaticallyOnboardedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
validationQuestionsAnsweredAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

HouseholdAssetsSummary: {
        fields: {
          illiquidPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
illiquidValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inEstateIlliquidPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inEstateIlliquidValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inEstateLiquidPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inEstateLiquidValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inEstateValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
liquidPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
liquidValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateCharityValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateFamilyValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateIlliquidPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateIlliquidValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateLiquidPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateLiquidValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

HouseholdMetrics: {
        fields: {
          inEstateValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateCharityValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateFamilyValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalEstateValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

HypotheticalCLT: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

HypotheticalCRT: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

HypotheticalGRAT: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

HypotheticalInsurance: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
transferValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

HypotheticalSaleLoan: {
        fields: {
          afrRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
startDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

HypotheticalTransferAsset: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
valueAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
valuePercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

HypotheticalTransferFundingSource: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
proRataAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
proRataPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

HypotheticalWaterfallDispositiveProvisionTemplate: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ILITCrummeyLetter: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
sendBefore: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
sentOn: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ILITTrust: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalPolicyCashValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

IRSConstants: {
        fields: {
          annualGiftTaxExclusionAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
federalEstateTaxPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
federalLongTermCapitalGrainsTaxPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
federalOrdinaryIncomeTaxPercentMaxBracket: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
gstExemptionAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
lifetimeExemptionAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
rate7520: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

Image: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

IncomeTaxDragDefaults: {
        fields: {
          federalIncomeTaxRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
federalLongTermCapitalGainsRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

IncomeTaxDragStateRates: {
        fields: {
          incomeTaxRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
longTermCapitalGainsRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

IncomeTaxPaymentConfig: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

IndividualPersonalAccount: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

InferredField: {
        fields: {
          acceptanceStatusSetAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

InferredFieldEvidence: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

InsightsTemplateBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

InsurancePersonalAccount: {
        fields: {
          beneficiaryDesignationsReviewedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalPolicyCashValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

InsurancePolicy: {
        fields: {
          cashValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
cashValueDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
conversionDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
deathBenefitAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
initialPremiumDueDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
loanBalanceOutstanding: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
nextPremiumDueDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
premiumAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
startDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

InsurancePremiumPayment: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
dueOn: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
paidOn: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
premiumAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

IntegrationAssetClass: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

IntegrationCashflow: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
endDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
growthRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
startDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

IntegrationClient: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

IntegrationConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

IntegrationEntity: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

IntegrationInsurance: {
        fields: {
          cashValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
premiumAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
startDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

IntegrationLiability: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
interestRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
recurringPaymentAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
termEnd: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
termStart: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
value: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

IntegrationPerson: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

InterestRateDetails: {
        fields: {
          interestRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

IrrevocableTrust: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

JointPersonalAccount: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGExportAnnotatedDocument: {
        fields: {
          executedOn: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGLoadingSession: {
        fields: {
          completedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
startedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGNode: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGRelationship: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGRoot: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGV2Document: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
executedOn: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
lastErrorAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
leaseExpiresAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
targetInstrumentDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGV2DocumentChange: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGV2DocumentModification: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
targetDescriptorDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGV2Graph: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGV2Node: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGV2NodeAlias: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGV2NodeEvidence: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGV2Statement: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveFrom: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveTo: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGV2StatementEvidence: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KGV2StatementSupersession: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KeyPerson: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

KeyPersonRole: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

LLCBusinessEntity: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
nongrantorControlledPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
nongrantorControlledValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ownershipAsOfDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

LPBusinessEntity: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
nongrantorControlledPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
nongrantorControlledValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ownershipAsOfDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

LiabilitiesBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Liability: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentAmountAsOfDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
finalPaymentAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
initialAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
interestPaid: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
interestRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
recurringPaymentAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
termEnd: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
termStart: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

LiabilityPayment: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
date: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
interestPaymentAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
newLiabilityAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
oldLiabilityAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
principalPaymentAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalPaymentAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

LiabilityPaymentCalculationDetails: {
        fields: {
          finalPaymentAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
finalPaymentInterestAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
finalPaymentPrincipalAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
recurringPaymentAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
termEnd: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
totalInterestPaid: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalPaid: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

LifeInsuranceBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

LifetimeExclusionEvent: {
        fields: {
          annualExclusionAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
ctImpliedExemptionUsed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ctTaxesPaidAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
discountAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
eventDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
giftAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
gstExclusionAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
lifetimeExclusionAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

LoggedTransfer: {
        fields: {
          amount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
transactionDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

LuminaryOrganization: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
jitEnabledAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

LuminaryTenantJIT: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
expiresAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ManagedSFTPConnection: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ManagedSFTPFileEntry: {
        fields: {
          lastModified: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ManagedSFTPPublicKey: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Memo: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

MemoPrompt: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Message: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
expiresAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

MissingDocumentOverride: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

MissingDocumentsPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ModelMapping: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

NoPlanProjection: {
        fields: {
          projectedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

NoPlanProjectionYearly: {
        fields: {
          beginningOfYear: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
endOfYear: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
growth: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

NodeStateInEstateStatus: {
        fields: {
          nonTaxableValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

NotificationApp: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
readAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

NotificationPreference: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

OpenaiSdkConfig: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

OrganizationApplicationConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
presentationApprovalRequiredSince: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
presentationAttestationRequiredSince: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

OrganizationDisclaimerConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

OwnershipStake: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
ownedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ownershipPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PercentageAccessParameterView: {
        fields: {
          percentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

PerformanceReport: {
        fields: {
          grantsToCharity: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
wealthTransferred: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

PlatformDocument: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PlatformFile: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PlatformFilePage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PlatformFileParagraph: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationApprovalRequest: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationAssetDistributionBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationAssetDistributionItemConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationAssetDistributionItemDetail: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationBundle: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationBundleCoverPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationBusinessOverviewBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationBusinessOverviewBusinessConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationBusinessOverviewItem: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationCoverPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationCoverSlideConfig: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationCustomPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationCustomPageBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationDiagramPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationDocumentsReviewedBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationDocumentsReviewedDocument: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationFamilyOverviewBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationFamilyOverviewMemberConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationHealthcareDirectiveBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationHealthcareDirectiveClientConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationHealthcareDirectiveItem: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationItemCitation: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationPlanningOpportunitiesBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationPlanningOpportunitiesItem: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationPowerOfAttorneyBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationPowerOfAttorneyClientConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationPowerOfAttorneyItem: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationTemplate: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationTemplateBundle: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationTemplateCoverPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationTemplateCustomPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationTemplateDiagramPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationTemplatePage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationTrustOverviewBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationTrustOverviewItem: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationTrustOverviewTrustConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationWillBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationWillClientConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PresentationWillItem: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Principal: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
ownershipPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

PrivateFoundation: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ProfessionalTeamRole: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Projection: {
        fields: {
          grantorRetainedInterest: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
initialFundingValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableGiftAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalAnnuityPayments: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalAssetValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
transferredOutOfEstate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

Proposal: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ProposalScenario: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ProposalScenarioProjectionValue: {
        fields: {
          estateTax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inEstate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

QPRTTrust: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
officialInterestRatePercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableGift: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
termEndDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
terminationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

QualifiedTuitionPersonalAccount: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Query: {
        fields: {
          npv: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
platformAUM: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

ReleaseGroup: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ReminderEmailNotificationRecord: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
sentAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

RetirementPersonalAccount: {
        fields: {
          beneficiaryDesignationsReviewedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

RevocableTrust: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Role: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

SCorpBusinessEntity: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
nongrantorControlledPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
nongrantorControlledValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ownershipAsOfDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

SLATTrust: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

SSOConnection: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

SalesforceExportAttempt: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

ScenarioTableRow: {
        fields: {
          annuityPayment: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
annuityPaymentPercentOfInitialFunding: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
beginningPrincipal: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
principalGrowth: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
remainderValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

ScheduledDistribution: {
        fields: {
          amount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
percentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

SessionHeartbeat: {
        fields: {
          inactiveAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
notAfter: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

SharingToken: {
        fields: {
          NotAfter: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

SimulateDispositiveProvision: {
        fields: {
          transferAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

SimulateDispositiveProvisions: {
        fields: {
          valueRemainingAfterFirstDeath: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
valueRemainingAfterSecondDeath: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

SoleProprietorshipBusinessEntity: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
currentDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
currentValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
effectiveDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
effectiveDiscountPercent: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledDiscountedValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grantorControlledValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
mostRecentValuationDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
nongrantorControlledPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
nongrantorControlledValue: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ownershipAsOfDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
taxDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

StateGiftTaxDetail: {
        fields: {
          ctTaxesPaid: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
exemptionUsed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
tax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableGiftsMade: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

StateInheritanceTaxDetail: {
        fields: {
          exemptionUsed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
federalEstateTaxDeduction: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
nonResidentStateTaxDeduction: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
tax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalTransferAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
valuationDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

StateTaxDetail: {
        fields: {
          adjustedTaxableGifts: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
apportionmentRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ctTaxesPaid: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
exemptionAvailable: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
exemptionUsed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
grossEstate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
inheritanceTaxCredit: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
nonTaxableTransfers: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
tax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableEstate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
tentativeStateTax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
valuationDiscount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

SubBrand: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

SubBrandDisclaimerConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Submission: {
        fields: {
          archivedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
completedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TaxDetail: {
        fields: {
          deductions: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
exemptionAvailable: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
exemptionCliff: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
exemptionUsed: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
portableExemption: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
tax: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableAmount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableAmountAfterExemption: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableTransfers: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
totalExemption: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
valuationDiscountApplied: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

TaxDragConfig: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
federalIncomeTaxRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
federalLongTermCapitalGainsRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
longTermCapitalGainReturnPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ordinaryIncomeReturnPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
qualifiedDividendReturnPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
stateIncomeTaxRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
stateLongTermCapitalGainsRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDragPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxFreeIncomeReturnPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TaxDragOverride: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
federalIncomeTaxRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
federalLongTermCapitalGainsRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
longTermCapitalGainReturnPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
ordinaryIncomeReturnPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
qualifiedDividendReturnPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
stateIncomeTaxRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
stateLongTermCapitalGainsRate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxDragPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxFreeIncomeReturnPercentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Team: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
workosUpdatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

Tenant: {
        fields: {
          contractStartDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
pendingDeletionSetAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
trialEndDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
workosUpdatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TenantApplicationConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
presentationApprovalRequiredSince: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
presentationAttestationRequiredSince: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TenantBranding: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TenantDisclaimerConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TenantDocument: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TenantInformation: {
        fields: {
          contractStartDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
trialEndDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TenantReminderEmailsConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TenantSSOConnection: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
jitEnabledAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TenantSecurityConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
luminarySupportAccessEndDate: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TenantSlideConfig: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TestCMKEncryption: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
encryptedTime: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TestamentaryEntity: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
inclusionRatio: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLDecimal.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
reviewedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TrustAdvisor: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TrustAdvisorRole: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TrustIncomeAccessParameterView: {
        fields: {
          amount: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
percentage: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLPercent.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

TrustPerformanceReport: {
        fields: {
          distributions: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
impliedEstateTaxSavings: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
outOfEstateGrowth: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
taxableGifts: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
transfers: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          },
wealthTransferred: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLCurrencyUSD.parseValue(value);
              }
              // Handle limited decimal objects from cache (e.g., {"s":1,"e":7,"d":[1,3990000]})
              // These are created when Decimal.toJSON() is called during serialization
              if (value != null && !Decimal.isDecimal(value) && typeof value === 'object') {
                // Check if it looks like a limited decimal object
                const obj = value as Record<string, unknown>;
                if ('s' in obj && 'e' in obj && 'd' in obj) {
                  // Reconstruct Decimal instance using Object.create + Object.assign
                  // This preserves the Decimal prototype chain and internal state
                  const decimal = Object.create(Decimal.prototype);
                  Object.assign(decimal, obj);
                  return decimal as Decimal;
                }
              }
              return value;
            }
          }
        }
      },

Trustee: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

TrusteeDuty: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

User: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
workosUpdatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

UserFeedback: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

UserNotificationConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

WaterfallBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

WaterfallBundleCoverPage: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

WaterfallComparisonBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

WaterfallComparisonTemplateBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

WaterfallTemplateBundleConfiguration: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

WorkOSOrganization: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
workosDirectoryUpdatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

WorkOSOrganizationDomain: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      },

WorkflowTracker: {
        fields: {
          createdAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
endedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
startedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          },
updatedAt: {
            read(value: unknown) {
              if (typeof value === 'string') {
                return GraphQLTime.parseValue(value);
              }
              return value;
            }
          }
        }
      }
};